// extracted by mini-css-extract-plugin
export default {"container":"zP-z","modal":"AP-z","dimensions":"BP-z","brandName":"CP-z","productName":"DP-z","recipientEmail":"EP-z","recommendedFit":"FP-z","hiddenField":"GP-z"};